/**
 * @file Полноэкранный прелоудер — тот же визуал, что у лоадера
 * turbo-frame#modal[aria-busy] (стили: .preloader в _preloader.scss).
 * Элемент создаётся лениво при первом показе и добавляется в body.
 */

let element = null

/**
 * Показывает прелоудер, при необходимости создавая элемент.
 * @param {{ label?: string }} [options] — label: текст для скринридеров
 */
export function showPreloader({ label } = {}) {
  // isConnected: после Turbo-навигации body заменяется и старый элемент отрывается от DOM
  if (!element || !element.isConnected) {
    element = document.createElement('div')
    element.className = 'preloader'
    element.setAttribute('role', 'status')

    if (label) {
      const srText = document.createElement('span')
      srText.className = 'sr-only'
      srText.textContent = label
      element.appendChild(srText)
    }

    document.body.appendChild(element)
  }

  element.hidden = false
}

/** Прячет прелоудер (элемент остаётся в DOM для повторного использования). */
export function hidePreloader() {
  if (element) element.hidden = true
}

// Возврат по кнопке «Назад» не должен показывать зависший кружок.
//
// Восстановить страницу могут двое, и события у них разные.
//
// 1. Браузер из bfcache. Основной случай: у нас <body data-turbo="false">,
//    поэтому сабмит формы — обычная полная навигация, и уход со страницы Turbo
//    не видит вовсе. Документ замораживается вместе с показанным прелоудером и
//    возвращается как есть; ловится только через pageshow. Проверено на проде:
//    после «Назад» navType остаётся 'navigate', то есть это именно bfcache.
// 2. Turbo из своего кеша — там, где переход шёл через Turbo.visit: выбор
//    подсказки в поиске, фильтры каталога.
window.addEventListener('pageshow', hidePreloader)
document.addEventListener('turbo:before-cache', hidePreloader)
